import { Subject, BehaviorSubject, throttle, interval, takeUntil, fromEvent, map, filter, bufferWhen, race } from 'rxjs';
export class VimePlayerProgress {
  get ready() {
    return this.ready$.getValue();
  }
  constructor(options) {
    this.options = options;
    this.onDestroy$ = new Subject();
    this.onReset$ = new Subject();
    this.ready$ = new BehaviorSubject(false);
    this.savedProgressSeconds$ = new BehaviorSubject(0);
    this.onPlayerProgress$ = new Subject();
    // Emits on throttle interval, or when the loaded video changes (triggers reset), to flush progress buffer
    this.bufferTrigger$ = race(interval(this.options.throttleInterval), this.onReset$);
    this.onPlayerProgressThrottled$ = this.onPlayerProgress$.pipe(bufferWhen(() => this.bufferTrigger$), filter(buffer => buffer.length > 0), map(buffer => {
      const filteredBuffer = buffer.filter(progress => progress.videoId === buffer[0].videoId);
      const last = filteredBuffer[filteredBuffer.length - 1];
      return {
        ...last,
        watchedSeconds: filteredBuffer.reduce((total, progress) => {
          return total + progress.watchedSeconds;
        }, 0)
      };
    }), takeUntil(this.onDestroy$));
  }
  initialize(player, url) {
    this.player = player;
    this.url = url;
    fromEvent(player, 'vmCurrentTimeChange').pipe(throttle(() => interval(1000)), takeUntil(this.onDestroy$)).subscribe(e => {
      const currentTime = e.detail;
      const totalTime = player.duration;
      this.updateUnlockedProgress();
      if (currentTime && totalTime) {
        this.onPlayerProgress$.next({
          percent: Math.ceil(currentTime / totalTime * 10000) / 10000,
          // round to 4 digits after decimal point
          currentTime: Math.ceil(currentTime),
          watchedSeconds: 1,
          url,
          videoId: this.videoId
        });
      }
    });
    this.ready$.next(true);
  }
  setVideoId(id) {
    this.videoId = id;
  }
  getSavedProgressSeconds() {
    if (!this.ready) throw new Error('getSavedProgressSeconds called before VimePlayerProgress Plugin was initialized!');
    return this.savedProgressSeconds$.getValue();
  }
  setSavedProgressSeconds(val) {
    if (typeof val !== 'number') throw new Error('Invalid value passed to setSavedProgressSeconds!');
    return this.savedProgressSeconds$.next(val);
  }
  updateUnlockedProgress() {
    const player = this.player;
    if (player && !player.paused) {
      const savedProgressSeconds = player.currentTime;
      if (savedProgressSeconds > this.savedProgressSeconds$.getValue()) this.setSavedProgressSeconds(savedProgressSeconds);
    }
  }
  setUnlockedProgress(progressInPercent) {
    const player = this.player;
    if (player?.duration > 0) {
      const savedProgressSeconds = player.duration * progressInPercent;
      if (savedProgressSeconds > this.savedProgressSeconds$.getValue()) this.setSavedProgressSeconds(savedProgressSeconds);
    }
  }
  reset() {
    this.onReset$.next(true);
    this.setSavedProgressSeconds(0);
  }
  destroy() {
    this.onDestroy$.next(true);
  }
}